/**
 * @desc 门店星际化配置信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 星际化编码 */
  code: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.StarEnum>>(
    `/storeapi/api/v3/store/star/channel`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.StarEnum>;
export default req;
